import React from "react";
import { useTranslation } from "react-i18next";
import { Button, ButtonVariant } from "@/components/ui/button";
import { Add } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";

interface NewPersonButtonProps {
  onClick: () => void;
  isDealMode?: boolean;
  variant?: ButtonVariant;
  text?: string;
}

const NewPersonButton: React.FC<NewPersonButtonProps> = ({
  onClick,
  isDealMode = true,
  variant,
  text
}) => {
  const { t } = useTranslation();

  return (
    <Button variant={variant || "primary"} onClick={onClick}>
      <IconContainer color="current" size="5">
        <Add />
      </IconContainer>
      {text ||
        t(`detailedView.peopleTab.${isDealMode ? "addPeople" : "addPerson"}`)}
    </Button>
  );
};

export default NewPersonButton;
